import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { CustomHttpErrorHandler } from './custom-http.handler';
import { CustomHttpErrorInterceptor } from './custom-http.interceptor';
import {
  CustomBadRequestHandler,
} from './handlers/index';

export const customErrorHandlers: Provider[] = [
  {
    provide: CustomHttpErrorHandler,
    useExisting: CustomBadRequestHandler,
    multi: true,
  }
];

export const customHttpErrorInterceptors: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useExisting: CustomHttpErrorInterceptor,
    multi: true,
  },
];
